import ReportsComparisons from "./Comparisons";

export default ReportsComparisons;
